import { render, staticRenderFns } from "./RecipeModal.vue?vue&type=template&id=b71ac87e&"
import script from "./RecipeModal.vue?vue&type=script&lang=js&"
export * from "./RecipeModal.vue?vue&type=script&lang=js&"
import style0 from "./RecipeModal.vue?vue&type=style&index=0&id=b71ac87e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports